import React from 'react'
import { Typography, Button, Card, Row, Col } from 'antd'
import { RightOutlined } from '@ant-design/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVial, faHeartPulse, faLungs, faDna, faVirus } from '@fortawesome/free-solid-svg-icons'
import '../../../styling/TestPromo.css'
import { useDispatch, useSelector } from 'react-redux'
import PatClinicConsultBooking from '../../../../../Clinic Consultation'
import CoreEnums from '../../../../../../../core/utils/enums'
import coreReducer from '../../../../../../../core/utils/reducer'

const { Title, Text } = Typography

const TestPromo = ({ onViewAll, onBookTest }) => {
  const dispatch = useDispatch()
  const tests = useSelector((state) => state.careSyncTests.data || [])

  // Handle booking a test
  const handleClinicBooking = (key) => {
    if (onBookTest && typeof onBookTest === 'function') {
      onBookTest('tests')
      return
    }

    dispatch(
      coreReducer.actions.addTab({
        key: `${CoreEnums.tabKeys.MY_BOOKINGS}_new_clinic_booking`,
        closable: true,
        label: CoreEnums.tabKeys.MY_BOOKINGS,
        children: <PatClinicConsultBooking isCaresync={true} testKey={key} />
      })
    )
  }

  // Handle view all tests
  const handleViewAllTests = () => {
    if (onViewAll && typeof onViewAll === 'function') {
      onViewAll('tests')
    }
  }

  // Map test categories to icons
  const testIcons = {
    tumorMarkers: { icon: faDna, color: '#FF6B6B' },
    cardiology: { icon: faHeartPulse, color: '#EF8D9C' },
    poc: { icon: faVial, color: '#1890FF' },
    respiratory: { icon: faLungs, color: '#52C41A' },
    virology: { icon: faVirus, color: '#FF7676' }
  }

  // Get featured tests
  const featuredTests = React.useMemo(() => {
    return tests
      .filter((test) => test.featured)
      .map((test) => ({
        id: test._id,
        name: test.name,
        description: test.description,
        price: `R${test.price?.toFixed(2) || '0.00'}`,
        icon: testIcons[test.category]?.icon || faVial,
        iconColor: testIcons[test.category]?.color || '#1890FF',
        test
      }))
  }, [tests])

  return (
    <div className='cs-test-promo'>
      <div className='cs-test-header'>
        <Title level={5}>Popular Tests</Title>
        <Button type='link' className='cs-view-all-btn' onClick={handleViewAllTests}>
          View All <RightOutlined />
        </Button>
      </div>

      <Row gutter={[12, 12]} className='cs-test-grid'>
        {featuredTests.slice(0, 4).map((test) => (
          <Col span={12} key={test.id || `test-${Math.random()}`}>
            <Card className='cs-test-card' onClick={() => handleClinicBooking(test.test?.key)}>
              <div className='cs-test-icon-wrapper' style={{ backgroundColor: `${test.iconColor}15` }}>
                <FontAwesomeIcon icon={test.icon} style={{ color: test.iconColor }} />
              </div>

              <div className='cs-test-info'>
                <Text className='cs-test-name'>{test.name}</Text>
                <Text className='cs-test-price'>{test.price}</Text>
                <Button type='primary' size='small' className='cs-book-btn'>
                  Book
                </Button>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  )
}

export default TestPromo
